import React, { useEffect, useRef } from "react";
import {
  BrowserRouter,
  Route,
  Router,
  Routes,
  useNavigate,
} from "react-router-dom";
import { APP_ROUTES } from "./pageRoutes";
import Home from "../Pages/Home";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsOfUse from "../Pages/TermsOfUse";
import RefundPolicy from "../Pages/RefundPolicy";
import ConsultDoctor from "../Pages/BookAppointment/ConsultDoctor";
import BookConsultant from "../Pages/BookAppointment/BookConsultant";
import Checkout from "../Pages/BookAppointment/Checkout";
// newly added page imports from patient app
import VideoCall from "../Pages/VideoConsultation";
import MedicaHistory from "../Pages/MedicalRecords/MedicaHistory";
import MyPresctription from "../Pages/MedicalRecords/MyPrescription";
import MyVitals from "../Pages/MedicalRecords/MyVitals/MyVitals";
import MyReports from "../Pages/MedicalRecords/MyReports";
import ForgotPassword from "../Authentication/ForgotPassword";
import Sharecallpatient from "../Pages/VideoConsultation/Sharecallpatient";
import PaymentPage from "../Pages/PaymentInitiation";
// import SharePrescription from "../Pages/MedicalRecords/MyPrescription/SharePrescription";
import LabPrescription from "../Pages/MedicalRecords/MyPrescription/LabPrescription";
import PharmacyPrescription from "../Pages/MedicalRecords/MyPrescription/PharmacyPrescription";
import PrescriptionTemplate from "../Pages/MedicalRecords/MyPrescription/PrescriptionTemplate";
import MyLabReports from "../Pages/MedicalRecords/MyLabReports";
import MyAppointments from "../Pages/MyAppointments";
import MyProfile from "../Pages/MyProfile";
import MedicalRecords from "../Pages/MedicalRecords";
import Payments from "../Pages/Payments";
import Settings from "../Pages/Settings";
import FamilyMembers from "../Pages/FamilyMembers";
import HealthSummary from "../Pages/HealthSummary";
import PHRACCESS from "../Pages/HealthSummary/PhrAccess";
import HospitalService from "../Pages/HospitalService";
import Consent from "../Pages/Consent/Consent";
import DashboardNew from "../Pages/DashboardNew/DashboardNew";
import LogConsent from "../Pages/Consent/LogConsent";
import CartPaymentPage from "../Pages/MyAppointments/CartPaymentPage";
import OrderHistory from "../Pages/OrderHistory";
import GiveConsent from "../DirectLinkPages/GiveConsent";
import BookLabtest from "../Pages/BookLabTest";
import BookMedicines from "../Pages/BookMedicine";
import MedicineDetails from "../Pages/BookMedicine/medicineDetails";
import LabTestDetails from "../Pages/BookLabTest/TestDetails";
import Cart from "../Pages/Cart";
import SharePrescription from "../DirectLinkPages/Prescription";
import LabReportLink from "../DirectLinkPages/LabReportLink";
import SharePaymentLink from "../DirectLinkPages/SharePaymentLink";
import ShareCall from "../DirectLinkPages/ShareCall";
import Notification from "../Pages/Notifications";
import PatientDevices from "../Pages/Devices";
import HealthPlans from "../Pages/HealthcarePlans/HealthPlans";
import Membership from "../Pages/Membership";
import JoinMembership from "../Pages/Membership/JoinMembership";
import { deleteDataFromLocal } from "../Redux/actions/AuthActions";
import { useDispatch } from "react-redux";
import MobileConsent from "../DirectLinkPages/MobileConsent";
import ProcedureList from "../Pages/Procedure";

export const PageRoutes = () => {
  const navigate = useNavigate();
  const idleTimerRef = useRef(null);
  const dispatch = useDispatch();

  const handleIdle = () => {
    localStorage.clear();
    sessionStorage.clear();
    if ("caches" in window) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }
    dispatch(deleteDataFromLocal());
    navigate("/");
  };

  useEffect(() => {
    const resetTimer = () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(handleIdle, 7200000);
    };
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  return (
    <Routes>
      <Route path={APP_ROUTES.LOGIN} element={<Home />} />
      <Route path={APP_ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      <Route path={APP_ROUTES.TERMSOFUSE} element={<TermsOfUse />} />
      <Route path={APP_ROUTES.REFUNDPOLICY} element={<RefundPolicy />} />
      <Route path={APP_ROUTES.CONSULTDOCTOR} element={<ConsultDoctor />} />
      <Route path={APP_ROUTES.DOCTORDETAILS} element={<BookConsultant />} />
      <Route path={APP_ROUTES.CHECKOUT} element={<Checkout />} />
      <Route path={APP_ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      {/* newly added pages from patient app */}
      <Route
        exact
        path={APP_ROUTES.SHARECALLPATIENT}
        element={<Sharecallpatient />}
      />
      <Route path={APP_ROUTES.MYAPPOINMENTS} element={<MyAppointments />} />
      <Route path={APP_ROUTES.MYPROFILE} element={<MyProfile />} />
      <Route path={APP_ROUTES.MEDICALRECORDS} element={<MedicalRecords />} />
      <Route path={APP_ROUTES.MEDICALHISTORY} element={<MedicaHistory />} />
      <Route path={APP_ROUTES.MYPRESCRIPTION} element={<MyPresctription />} />
      <Route path={APP_ROUTES.LABPRSCRIPTION} element={<LabPrescription />} />
      <Route
        path={APP_ROUTES.PHARMACYPRSCRIPTION}
        element={<PharmacyPrescription />}
      />
      <Route path={APP_ROUTES.CARTPAGEPAYMENT} element={<CartPaymentPage />} />
      <Route path={APP_ROUTES.MYVITALS} element={<MyVitals />} />
      <Route path={APP_ROUTES.MYREPORTS} element={<MyReports />} />
      <Route path={APP_ROUTES.MYLABREPORTS} element={<MyLabReports />} />
      <Route path={APP_ROUTES.PAYMENTS} element={<Payments />} />
      <Route path={APP_ROUTES.VIDEOCALL} element={<VideoCall />} />
      <Route path={APP_ROUTES.FORGOTPASSWORD} element={<ForgotPassword />} />
      <Route
        path={APP_ROUTES.PrescriptionTemplate}
        element={<PrescriptionTemplate />}
      />
      <Route path={APP_ROUTES.PHONEPEPAYMENT} element={<PaymentPage />} />
      <Route path={APP_ROUTES.SETTINGS} element={<Settings />} />
      <Route path={APP_ROUTES.FAMILYMEMBERS} element={<FamilyMembers />} />
      <Route path={APP_ROUTES.PHRACCESS} element={<PHRACCESS />} />
      <Route path={APP_ROUTES.HEALTHSUMMARY} element={<HealthSummary />} />
      <Route path={APP_ROUTES.HOSPITALSERVICE} element={<HospitalService />} />
      <Route path={APP_ROUTES.MEDICINES} element={<BookMedicines />} />
      <Route path={APP_ROUTES.LABTESTS} element={<BookLabtest />} />
      <Route path={APP_ROUTES.CONSENT} element={<Consent />} />
      <Route path={APP_ROUTES.DASHBOARDNEW} element={<DashboardNew />} />
      <Route path={APP_ROUTES.LOGCONSENT} element={<LogConsent />} />
      <Route path={APP_ROUTES.ORDERHISTORY} element={<OrderHistory />} />
      <Route path={APP_ROUTES.GIVECONSENT} element={<GiveConsent />} />
      <Route path={APP_ROUTES.BOOKMEDICINE} element={<BookMedicines />} />
      <Route path={APP_ROUTES.BOOKLABTEST} element={<BookLabtest />} />
      <Route path={APP_ROUTES.MEDICINEDETAILS} element={<MedicineDetails />} />
      <Route path={APP_ROUTES.LABTESTDETAILS} element={<LabTestDetails />} />
      <Route path={APP_ROUTES.CART} element={<Cart />} />
      <Route path={APP_ROUTES.NOTIFICATION} element={<Notification />} />
      <Route path={APP_ROUTES.DEVICES} element={<PatientDevices />} />
      <Route path={APP_ROUTES.PROCEDURELIST} element={<ProcedureList />} />
      {/* Direct Link Components */}
      <Route
        path={APP_ROUTES.SHAREPRSCRIPTION}
        element={<SharePrescription />}
      />
      <Route
        path={APP_ROUTES.SHAREPAYMENTLINK}
        element={<SharePaymentLink />}
      />
      <Route path={APP_ROUTES.SHARECALL} element={<ShareCall />} />
      <Route path={APP_ROUTES.LABREPORTLINK} element={<LabReportLink />} />
      <Route path={APP_ROUTES.HEALTHPLANS} element={<HealthPlans />} />
      <Route path={APP_ROUTES.MEMBERSHIP} element={<Membership />} />
      <Route path={APP_ROUTES.JOINMEMBERSHIP} element={<JoinMembership />} />
      <Route path={APP_ROUTES.MOBILECONSENT} element={<MobileConsent />} />

      {/* Direct Link Components */}
    </Routes>
  );
};
